type SpinnerSize = "xs" | "sm" | "md" | "lg";

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

export function LoadingSpinner({ size, className }: LoadingSpinnerProps) {
  const classes = ["loading loading-spinner", size && `loading-${size}`, className]
    .filter(Boolean)
    .join(" ");
  return <span className={classes} />;
}
